// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pcat-list.cidx-screen {
  gap: 20px;
  padding-top: 20px;
}

.pcat-list .cidx-heading {
  align-items: center;
  padding-bottom: 0;
  border-bottom: 0;
}

.pcat-list .cidx-subtitle {
  margin-top: 4px;
  font-size: 14px;
  line-height: 20px;
  color: #64748b;
}

.pcat-list .cidx-count {
  font-weight: 500;
}

.pcat-list .cidx-btn--secondary {
  border-color: #cbd5e1;
  font-weight: 500;
  color: #334155;
}

.pcat-list .cidx-toolbar > .cidx-btn {
  margin-inline-start: auto;
}

.pcat-list .cidx-html-table th {
  background: #ffffff;
  padding-top: 12px;
  padding-bottom: 12px;
}

.pcat-list .cidx-html-table td {
  padding-top: 12px;
  padding-bottom: 12px;
  white-space: normal;
}

.pcat-list .cidx-html-table th.is-id,
.pcat-list .cidx-html-table td.is-id {
  width: 56px;
}

.pcat-list .cidx-mono.is-id {
  color: #64748b;
  font-weight: 500;
}

.pcat-name {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.pcat-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #0284c7;
  flex-shrink: 0;
}

.pcat-list .cidx-pager {
  padding: 12px 16px;
}

.pcat-list .cidx-pager__meta {
  font-weight: 400;
  color: #64748b;
}

.pcat-pager__strong {
  font-weight: 600;
  color: #0f172a;
}

.pcat-list .cidx-pager__btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  border-radius: 8px;
  font-weight: 500;
}

.pcat-list .cidx-pager__btn:disabled {
  background: #f8fafc;
  color: #94a3b8;
  opacity: 1;
}

.pcat-pager__current {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #0ea5e9;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

[dir='rtl'] .pcat-list .cidx-pager__btn .anticon {
  transform: scaleX(-1);
}
`, "",{"version":3,"sources":["webpack://./src/pages/inventory/ProductCategories/style.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".pcat-list.cidx-screen {\n  gap: 20px;\n  padding-top: 20px;\n}\n\n.pcat-list .cidx-heading {\n  align-items: center;\n  padding-bottom: 0;\n  border-bottom: 0;\n}\n\n.pcat-list .cidx-subtitle {\n  margin-top: 4px;\n  font-size: 14px;\n  line-height: 20px;\n  color: #64748b;\n}\n\n.pcat-list .cidx-count {\n  font-weight: 500;\n}\n\n.pcat-list .cidx-btn--secondary {\n  border-color: #cbd5e1;\n  font-weight: 500;\n  color: #334155;\n}\n\n.pcat-list .cidx-toolbar > .cidx-btn {\n  margin-inline-start: auto;\n}\n\n.pcat-list .cidx-html-table th {\n  background: #ffffff;\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n\n.pcat-list .cidx-html-table td {\n  padding-top: 12px;\n  padding-bottom: 12px;\n  white-space: normal;\n}\n\n.pcat-list .cidx-html-table th.is-id,\n.pcat-list .cidx-html-table td.is-id {\n  width: 56px;\n}\n\n.pcat-list .cidx-mono.is-id {\n  color: #64748b;\n  font-weight: 500;\n}\n\n.pcat-name {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.pcat-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  background: #0284c7;\n  flex-shrink: 0;\n}\n\n.pcat-list .cidx-pager {\n  padding: 12px 16px;\n}\n\n.pcat-list .cidx-pager__meta {\n  font-weight: 400;\n  color: #64748b;\n}\n\n.pcat-pager__strong {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.pcat-list .cidx-pager__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 32px;\n  border-radius: 8px;\n  font-weight: 500;\n}\n\n.pcat-list .cidx-pager__btn:disabled {\n  background: #f8fafc;\n  color: #94a3b8;\n  opacity: 1;\n}\n\n.pcat-pager__current {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: #0ea5e9;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n[dir='rtl'] .pcat-list .cidx-pager__btn .anticon {\n  transform: scaleX(-1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
